export default __webpack_public_path__ + "static/media/sports.6ff55765.svg";